import {Base64} from 'js-base64';

// 加密
function encode(object) {
	let str = JSON.stringify(object || {mobile: '123', isMember: false});
	let strlist = Base64.encode(str).split('').reduce(function (list, val, index) {
		if (index < 3) {
			list.push(val);
		} else {
			switch (index % 3) {
				case 0:
					list.unshift(val);
					break;
				case 1:
					list.unshift(val);
					break;
				default:
					list.push(val);
			}
		}
		return list;
	}, []);
	strlist.push(...strlist.splice(0, 2));
	return strlist.join("");
}

function decode(string) {
	let strlist = (string||'').split('');
	let len = strlist.length;
	// 移动后面两个字符串到首部
	strlist.unshift(...strlist.splice(-2));
	// 对字符list进行克隆遍历
	strlist = strlist.slice().reduce(function (list, val, index) {
		// 检查是否最后三个字符
		if (index >= (len - 3)) {
			let str = strlist.pop()
			list.push(str);
		} else {
			switch ((len - index - 1) % 3) {
				case 0:
					// 获取字符list第一个字符，添加到新的list后边
					list.push(strlist.shift());
					break;
				case 1:
					// 获取字符list第一个字符，添加到新的list后边
					list.push(strlist.shift());
					break;
				default:
					// 获取字符list最后一个字符，添加到新的list后边
					list.push(strlist.pop());
			}
		}
		return list;
	}, []);
	// 进行反转，并进行字符连接
	let res = Base64.decode(strlist.reverse().join(""));
	
	try {
		res = JSON.parse(res)
	}
	catch (e) {
		res = null;
	}
	return res;
}

// 加密成url参数
function encodeToUrl(obj) {
	return encodeURIComponent(encode(obj));
}

export {
	encode,
	decode,
	encodeToUrl,
}